import { useTranslation } from "@i18n";
import { convertDate } from "@Services/luxonHelper";

import UserNameTagComponent from "@CubeComponents/html/UserNameTagComponent";

function ReviewBasicDetails({
  reviewFlowName,
  createdBy,
  currentReviewLevelSerial,
  currentReviewLevelTitle,
  nextActionDueDate,
  createdDate,
  finishedDate,
  numberOfEntitiesAttached,
}: any) {
  const { t } = useTranslation();
  const getFormattedDate = (date: any) => {
    if (date) {
      return convertDate(Number(date), "dateForText");
    }

    return "-";
  };

  const getUserAvatarComponent = (user: any) => <UserNameTagComponent id={user.userId} />;

  return (
    <div className="pb-6 ps-4">
      <div className="flex flex-row items-center justify-between py-3">
        <span className="text-base font-semibold">{t("Review Flow Name")}</span>
        <div className="w-[60%] self-start">
          <span>{reviewFlowName}</span>
        </div>
      </div>

      <div className="flex flex-row items-center justify-between py-3">
        <span className="text-base font-semibold">{t("Created by")}</span>
        <div className="w-[60%] self-start">
          <span
            className="text-base font-semibold flex-1 overflow-hidden text-ellipsis whitespace-nowrap cursor-pointer"
            data-testid="userProfileDetail"
          >
            {getUserAvatarComponent(createdBy)}
          </span>
        </div>
      </div>

      <div className="flex flex-row items-center justify-between py-3">
        <span className="text-base font-semibold">{t("Waiting For")}</span>
        <div className="w-[60%] self-start">
          <span>
            {currentReviewLevelSerial && currentReviewLevelTitle
              ? `${currentReviewLevelSerial} - ${currentReviewLevelTitle}`
              : "-"}
          </span>
        </div>
      </div>

      <div className="flex flex-row items-center justify-between py-3">
        <span className="text-base font-semibold">{t("Next Action Due")}</span>
        <div className="w-[60%] self-start">
          <span>{getFormattedDate(nextActionDueDate)}</span>
        </div>
      </div>

      <div className="flex flex-row items-center justify-between py-3">
        <span className="text-base font-semibold">{t("Created On")}</span>
        <div className="w-[60%] self-start">
          <span>{getFormattedDate(createdDate)}</span>
        </div>
      </div>

      <div className="flex flex-row items-center justify-between py-3">
        <span className="text-base font-semibold">{t("Finished On")}</span>
        <div className="w-[60%] self-start">
          <span>{getFormattedDate(finishedDate)}</span>
        </div>
      </div>

      <div className="flex flex-row items-center justify-between py-3">
        <span className="text-base font-semibold">{t("Contents")}</span>
        <div className="w-[60%] self-start">
          <span>{numberOfEntitiesAttached}</span>
        </div>
      </div>
    </div>
  );
}

export default ReviewBasicDetails;
